<template>
	<div :class="[style.switcherLabels, themeClass]">
		<span :class="[!checked ? style.switcherLabelsActive : '']"><slot name="left"></slot></span>
		<switcher :class="[style.switcherLabelsSwitcher]" :theme="theme" :value="value" :disabled="disabled" @change="inputHandle" />
		<span :class="[checked ? style.switcherLabelsActive : '']"><slot name="right"></slot></span>
	</div>
</template>

<script>
	import style from './style.module.scss'
	import switcher from '@/components/controls/switcher/switcher.vue'

	export default {
		name: 'switcher-labels',
		components: {
			switcher
		},
		props: {
			value: {
				type: Boolean,
				default: false,
				required: false
			},
			disabled: {
				type: Boolean,
				default: false,
				required: false,
			},
			theme: {
				type: String,
				default: 'white',
				required: false
			}
		},
		data() {
			return {
				style: style,
				checked: this.value
			}
		},
		methods: {
			inputHandle(event) {
				this.checked = event;
				this.$emit('change', event)
			}
		},
		computed: {
			themeClass() {
				return this.theme == 'black' ? this.style.switcherLabelsBlack : this.style.switcherLabelsWhite
			}
		}
	}
</script>